/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	UPDATE_AUTHENTICATED_USER(state, data) {
    localStorage.setItem('token', data.token);
		localStorage.setItem('userInfo', JSON.stringify(data.user));
    localStorage.setItem('userRole', data.role);
    state.userInfo = data.user
    state.userRole = data.role
  },
  UPDATE_AUTHENTICATED_ROLE(state, data) {
    localStorage.setItem('userRole', data);
    state.userRole = data.role
  },
  LOGOUT_USER(state, data) {
    localStorage.removeItem('token');
		localStorage.removeItem('userInfo');
    localStorage.removeItem('userRole');
  }
}